/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AgentResourcePairing { 
    /**
     * Agent Id
     */
    agent_id?: string;
    /**
     * Agent name
     */
    agent_display_name?: string;
    /**
     * Org Id
     */
    org_id?: string;
    /**
     * Resource Id [VC for SRM, SDDC for VSR]
     */
    resource_id?: string;
    /**
     * Resource name
     */
    resource_display_name?: string;
    /**
     * Resource FQDN
     */
    resource_fqdn?: string;
}

